export enum SessionAction {
  CREATE,
  DISCARD,
  KEEP,
  REJOIN,
  RUN_WITH_ETLS,
  RUN_WITHOUT_ETLS,
}

export interface SessionModalResponse {
  //If no sessionId is returned then it is assumed that the modal does not know about sessions
  sessionId?: string
  action: SessionAction
}
